module.exports = __webpack_public_path__ + "static/media/item-9.50132b33.png";